/**
 * 询价配置
 * {
 *   name: 调用接口的别名
 *   url：api
 *   method：get | post | put | delete
 * }
 */
export default {
  ask: {
    name: "ask",
    url: "/ams/billquery/billQuery",
    method: "post"
  },
  ocr: {
    name: "ocr",
    url: "/ams/ocrBill/post_bps_ocrBill_billRecogize",
    method: "post"
  },
  ocrImg: {
    name: "ocrImg",
    url: "/ams/ocrBill/billRecogize",
    method: "post"
  },
  accountAuth: {
    name: "accountAuth",
    url: "/ams/assignor/thirdPartyAuth",
    method: "post"
  },
  list: {
    name: "list",
    url: "/ams/billquery/quertList",
    method: "get"
  },
  // 用户联系方式
  contact: {
    name: "contact",
    url: "/ams/assignor/contactInfo",
    method: "post"
  }
};
